import { loadFederatedModule } from '../../../utils/loadFederatedModule';

type WFHelpersDefault = typeof import('WF/Helpers').default;

export class KpiService {
  private static _helperServicePromise: Promise<WFHelpersDefault> | null = null;

  HelperService: WFHelpersDefault | null = null;

  private static getHelperServicePromise(): Promise<WFHelpersDefault> {
    if (!this._helperServicePromise) {
      this._helperServicePromise = loadFederatedModule<typeof import('WF/Helpers')>('WF/Helpers')
        .then((m) => m.default)
        .catch((err) => null);
    }
    return this._helperServicePromise;
  }

  static async getIntegrationInfoForObject(params: {
    integrationType: number,
    objectType: typeof WOBO_OBJECT_TYPES[keyof typeof WOBO_OBJECT_TYPES],
    objectId: number;
  }): Promise<KpiData | null> {
    try {
      const Helper = await this.getHelperServicePromise();
      return Helper.getIntegrationInfo(params.integrationType, params.objectType, params.objectId)
        .then((response) => response?.kpiData?.items?.find((item) => item.active) ?? null)
    } catch {
      return null;
    }
  }

  static async deactivateIntegration(kpidataIds: string[]):
    Promise<DeactivateKpiDataResponse | null> {
    try {
      const Helper = await this.getHelperServicePromise();
      return Helper.deactivateKpidata(kpidataIds)
    } catch {
      return null;
    }
  }
}
